import React, { useState } from 'react';
import { Button } from './';
import { Tooltip } from 'reactstrap';

export const ActionButton = ({
	id,
	icon,
	tooltipText,
	tooltipPlacement = 'top',
	defaultColor = '#6E6B7B',
	hoverColor = '#56cc21',
	onClick,
	...other
}) => {
	const [bgColor, setBgColour] = useState(defaultColor);
	const [showTooltip, setShowTooltip] = useState(false);

	return (
		<>
			<Button
				id={id}
				className="btn-icon"
				color={'flat-secondary'}
				style={{
					padding: '5px',
					marginRight: '5px',
					backgroundColor: '#EFF2F7',
					borderRadius: '7px',
					color: bgColor
				}}
				onClick={onClick}
				onMouseOver={() => {
					setShowTooltip(true);
					setBgColour(hoverColor);
				}}
				onMouseOut={() => {
					setShowTooltip(false);
					setBgColour(defaultColor);
				}}
			>
				{icon}
			</Button>
			<Tooltip placement={tooltipPlacement} isOpen={showTooltip} target={id}>
				{tooltipText}
			</Tooltip>
		</>
	);
};

export default ActionButton;
